module.exports = __webpack_public_path__ + "static/media/m12tj93.8bb06cf3.png";